var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1854 28.6953H31.7222V62.8453H37.1854V28.6953Z",
    fill: "#4F90A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.3816 28.6953H39.9185V62.8453H45.3816V28.6953Z",
    fill: "#84C3C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.9925 28.6953H23.5293V62.8453H28.9925V28.6953Z",
    fill: "#84C3C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.4029 57.5476V25.5215H26.2603V20H53.869V49.1247V57.5476H48.4029Z",
    fill: "#4F90A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.35409 42.4283C8.31108 42.4283 10.7082 40.0057 10.7082 37.0172C10.7082 34.0286 8.31108 31.606 5.35409 31.606C2.39711 31.606 0 34.0286 0 37.0172C0 40.0057 2.39711 42.4283 5.35409 42.4283Z",
    fill: "#84C3C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M63.6749 42.4279C66.6319 42.4279 69.029 40.0052 69.029 37.0167C69.029 34.0281 66.6319 31.6055 63.6749 31.6055C60.7179 31.6055 58.3208 34.0281 58.3208 37.0167C58.3208 40.0052 60.7179 42.4279 63.6749 42.4279Z",
    fill: "#84C3C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.0039 53.6424L53.8652 57.5477L66.2384 45.0454H58.5102L50.0039 53.6424Z",
    fill: "#4F90A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.4578 57.5476V25.5215H42.6005V20H14.9946V49.1247V57.5476H20.4578Z",
    fill: "#4F90A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.8586 53.6424L14.9944 57.5477L2.62402 45.0454H10.3494L18.8586 53.6424Z",
    fill: "#4F90A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDm);
export default __webpack_public_path__ + "static/media/logoDM.cfc23d84c661f38504925d6c782ea796.svg";
export { ForwardRef as ReactComponent };